// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination__container--1kW7l","pagination":"Pagination__pagination--1fKX2","loadMore":"Pagination__loadMore--2F7Z8"};